import React from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AdminHeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/admin');
  };

  const goToWebsite = () => {
    window.open('/', '_blank')
  };

  return (
    <header className="flex items-center justify-between bg-[#020303] text-white px-4 py-3 shadow-md h-16">
      <div className="flex items-center gap-3">
        <button
          className="lg:hidden text-gray-300 hover:text-white"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <h1 className="text-lg font-medium">Admin Panel</h1>
      </div>

      <div className="flex gap-2">
        <button
          className="text-sm px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded transition"
          onClick={goToWebsite}
        >
          Go to Website
        </button>
        <button
          className="text-sm px-4 py-2 bg-[#009FE3] hover:bg-[#007bbf] text-white rounded transition"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
